<template>
  <v-row
      class="add-photo fill-height ma-0"
      align="center"
      justify="center"
  >
    <v-col
      v-if="!file"
      class="prompt"
      @click="handleClick"
    >
      <v-icon x-large>add</v-icon>
      Click to select photo
    </v-col>
    <v-progress-circular
      indeterminate
      color="grey"
      v-if="file && loading"
    />
    <input
      data-testid="add-photo-file-input"
      class="add-photo-file-input"
      type="file"
      ref="fileInput"
      name="facility_photo"
      style="display: none;"
      @change="handleChange"
    >
  </v-row>
</template>

<script>
export default {
  props: {
    dispatchMethod: String,
    additionalData: Object
  },

  data() {
    return {
      file: false,
      loading: false
    };
  },

  methods: {
    handleClick() {
      this.$refs.fileInput.click();
    },

    handleChange() {
      this.loading = true;
      this.file = this.$refs.fileInput.files[0];

      const formData = new FormData();
      formData.append("image", this.file);
      if (this.additionalData && Object.keys(this.additionalData).length) {
        for (const key in this.additionalData) {
          formData.append(key, this.additionalData[key]);
        }
      }

      this.$store.dispatch(this.dispatchMethod, formData)
        .then(() => {
          this.file = false;
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
  .prompt {
    cursor: pointer;
    height: 100%;
  }
</style>
